module.exports = __webpack_public_path__ + "public/images/slider/davidkina-circle.0f71099033174b403be849309dad542c.jpg";